import React from 'react';
import {JobSearchProps} from './SearchStandard';

export const SearchMobile = ({search, setSearch, setJobResultsPage, searchLabel}: JobSearchProps): JSX.Element => {
    return (
        <div className="toggleSearchButton" role="button" tabIndex={0}>
            <svg
                width="22"
                height="22"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3.75 9C3.75 6.10051 6.10051 3.75 9 3.75C11.8995 3.75 14.25 6.10051 14.25 9C14.25 11.8995 11.8995 14.25 9 14.25C6.10051 14.25 3.75 11.8995 3.75 9ZM9 2.25C5.27208 2.25 2.25 5.27208 2.25 9C2.25 12.7279 5.27208 15.75 9 15.75C12.7279 15.75 15.75 12.7279 15.75 9C15.75 5.27208 12.7279 2.25 9 2.25ZM15.5303 14.4697C15.2374 14.1768 14.7626 14.1768 14.4697 14.4697C14.1768 14.7626 14.1768 15.2374 14.4697 15.5303L17.4697 18.5303C17.7626 18.8232 18.2374 18.8232 18.5303 18.5303C18.8232 18.2374 18.8232 17.7626 18.5303 17.4697L15.5303 14.4697Z"
                    fill="black"
                />
            </svg>
            <input
                type="text"
                placeholder={searchLabel || 'Enter keywords'}
                value={search}
                onChange={(e) => {
                    setSearch(e.target.value);
                    setJobResultsPage(0);
                }}
            />
        </div>
    );
};
